import React, { useState, useEffect } from "react";
import { useLocation } from "react-router";
import { Card, Box } from "@material-ui/core";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import AjaxHelper from "../../apis/apiRequest";
import { Endpoint, Status } from "../../apis/apiConstants";
import { useNavigate } from "react-router";
import { startLoading, stopLoading } from "../../actions/loadingAction";
import { useDispatch } from "react-redux";
import { Image } from "react-bootstrap";
import placeholderBanner from "../../assets/Memon_NEWS_mobile.png";
import "./singleNews.scss";
import { errorSnackbar } from "../../actions/snackbarActions";
import { useSearchParams } from "react-router-dom";
import { isObjectEmpty } from "../../helpers/appFieldValidation";

const SingleNewsMobile = (props) => {
  const { state } = useLocation();
  const [news, setNews] = useState({});
  const [urlParams] = useSearchParams();

  const dispatch = useDispatch();

  useEffect(() => {
    const newsId = urlParams.get("news_id");
    if (newsId) {
      getNews(newsId);
    }
  }, []);

  const getNews = (id) => {
    const token = urlParams.get("token");
    dispatch(startLoading);
    AjaxHelper.getAxiosInstanceToken(token)
      .get(`${Endpoint.GET_NEWS}/${id}`)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          console.log(response.data.data);
          setNews(response.data.data);
        } else {
          dispatch(errorSnackbar("Error while fetching News."));
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error while fetching News."));
      });
  };

  return (
    <Box style={{ width: "100%", overflowX: "hidden" }}>
      {isObjectEmpty(news) ? null : (
        <Box
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            overflowX: "hidden",
          }}
        >
          <div className={"news-component"}>
            <Image
              src={news.imgUrl ?? placeholderBanner}
              alt="Uploaded"
              style={{
                maxWidth: "100%",
                maxHeight: "300px",
                objectFit: "cover",
              }}
            />

            <div
              style={{
                fontFamily: "MontserratBold",
                fontSize: 16,
                paddingRight: 16,
                paddingLeft: 16,
              }}
            >
              {news.headline}
            </div>

            <ReactQuill
              value={news.blog}
              style={{
                wordWrap: "break-word",
                paddingLeft: 12,
                paddingRight: 12,
                marginBottom: 16,
              }}
              modules={{
                toolbar: false,
              }}
              formats={[
                "header",
                "bold",
                "italic",
                "underline",
                "strike",
                "blockquote",
                "code-block",
                "list",
                "bullet",
                "link",
                "image",
              ]}
              placeholder="Write something amazing..."
              readOnly
            />
          </div>
        </Box>
      )}
    </Box>
  );
};

export default SingleNewsMobile;
